import { render } from "./DeleteConfirmPopup.vue?vue&type=template&id=1af45555&scoped=true&ts=true"
import script from "./DeleteConfirmPopup.vue?vue&type=script&lang=ts"
export * from "./DeleteConfirmPopup.vue?vue&type=script&lang=ts"

import "./DeleteConfirmPopup.vue?vue&type=style&index=0&id=1af45555&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af45555"]])

export default __exports__